import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {PDFExport, savePDF} from "@progress/kendo-react-pdf"
import {MDBBreadcrumb, MDBBreadcrumbItem} from "mdbreact"
import {useRef} from "react"

import MotAnnualTests from "../../components/MotHistory/motAnnualTests"
import MotSearchPanel from "../../components/MotHistory/motSearchPanel"
import {RootState} from "../../rootReducer"
import {LoadingPanel} from "../../shared/CommonItems"
import {useAppSelector} from "../../store"

export default function MotHistory(): JSX.Element {
    const vehicleDetails = useAppSelector((state: RootState) => state.containers.motHistory.vehicleDetails)
    const vehicleDetailsLoading = useAppSelector(
        (state: RootState) => state.containers.motHistory.vehicleDetailsLoading,
    )

    const pdfExportComponent = useRef<PDFExport>(null)
    const contentArea = useRef(null)

    const exportContentToPDF = () => {
        if (contentArea.current)
            savePDF(contentArea.current, {
                fileName: vehicleDetails.registration,
                paperSize: "A4",
                scale: 0.7,
                margin: "1cm",
            })
    }

    return (
        <>
            <MDBBreadcrumb>
                <MDBBreadcrumbItem>Manage MOT</MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>MOT History</MDBBreadcrumbItem>
            </MDBBreadcrumb>
            <div className="row">
                <div className="col-md-2 pe-0">
                    <MotSearchPanel></MotSearchPanel>
                </div>
                <div className="col-md-10">
                    <div
                        className="position-relative"
                        style={{
                            height: "calc(100vh - 10.4rem)",
                            overflowY: "auto",
                        }}
                    >
                        {vehicleDetailsLoading && <LoadingPanel />}
                        <Toolbar className="shadow-0 border-bottom p-2 position-sticky top-0 mb-2 mt-1 flex-row-reverse">
                            <ToolbarItem>
                                <Button
                                    fillMode="flat"
                                    themeColor={"primary"}
                                    iconClass="fas fa-file-pdf"
                                    onClick={e => exportContentToPDF()}
                                    disabled={vehicleDetails.vehicleId === 0}
                                >
                                    Export to PDF
                                </Button>
                            </ToolbarItem>
                        </Toolbar>
                        <PDFExport ref={pdfExportComponent}>
                            <div ref={contentArea}>{vehicleDetails.vehicleId !== 0 && <MotAnnualTests />}</div>
                        </PDFExport>
                    </div>
                </div>
            </div>
        </>
    )
}
